module.exports = __webpack_public_path__ + "places.svg?78121c9789a9e02e83bdcb7fca693abb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/places.svg
// module id = 138
// module chunks = 0